export const NOTIFICATION_TYPES_MAPPING = {
  CONVERSATION_MENTION: ['i-lucide-at-sign', 'text-n-woot-text'],
  CONVERSATION_ASSIGNMENT: ['i-lucide-chevrons-right', 'text-n-woot-text'],
  CONVERSATION_CREATION: ['i-lucide-mail-plus', 'text-n-woot-text'],
  PARTICIPATING_CONVERSATION_NEW_MESSAGE: [
    'i-lucide-message-square-plus',
    'text-n-woot-text',
  ],
  ASSIGNED_CONVERSATION_NEW_MESSAGE: [
    'i-lucide-message-square-plus',
    'text-n-woot-text',
  ],
  SLA_MISSED_FIRST_RESPONSE: ['i-lucide-heart-crack', 'text-n-ruby-11'],
  SLA_MISSED_NEXT_RESPONSE: ['i-lucide-heart-crack', 'text-n-ruby-11'],
  SLA_MISSED_RESOLUTION: ['i-lucide-heart-crack', 'text-n-ruby-11'],
  EVENT_CREATED: ['i-lucide-calendar-plus', 'text-n-woot-text'],
  EVENT_UPDATED: ['i-lucide-calendar-clock', 'text-n-woot-text'],
  EVENT_ASSIGNMENT: ['i-lucide-user-check', 'text-n-woot-text'],
  QUOTE_ACCEPTED: ['i-lucide-file-check-2', 'text-n-teal-11'],
  QUOTE_DECLINED: ['i-lucide-file-x-2', 'text-n-ruby-11'],
};
